<template>
  <div class="order-food-table-expand-btn">
    <span class="order-food-table-expand-btn__icon" :class="[disabled? 'is-disabled' : '']" @click="!disabled && $emit('icon-click')">
      <i :class="isExpand ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
    </span>
    <span>{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: 'OrderFoodExpandBtn',
  props: {
    name: {
      type: String,
      required: true
    },
    isExpand: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.order-food-table-expand-btn {
    display: flex;
    align-items: center;
    &__icon {
      margin-right: 8px;
      display: flex;
      align-items: center;
      cursor: pointer;
      &.is-disabled {
        cursor: not-allowed;
        color: $lightFontColor;
      }
    }
    &__icon i {
      font-size: 20px;
    }
  }
</style>
